import { IOperationModeType } from '../getCurrentUser/getCurrentUser.types';

export const getQueryKey = (operationMode: IOperationModeType) => [
  'search',
  'index',
  operationMode,
];
